export enum SiteCookies {
  ACCESS_TOKEN = 'C_SESSION_ID',
  REFRESH_TOKEN = 'C_REFRESHER',
  ORDER_PLACED = 'ORDER_PLACED',
}

export enum SiteStorage {
  RETURN_URL = 'return_url',
  IS_AGE_MODAL_VIEWED = 'isAgeModal_viewed',
  CANCEL_SUBSCRIPTION = 'cancel_subscription',
  DELIVERY_MEAL_PREFERENCE_DISMISSED = 'delivery-meal-preference-dismissed',
}
